import { defineStore } from 'pinia';
import type { dynamicObj } from 'src/pages/assets';

export const useDocTableTrainingStore = defineStore('doc_table_training', {
  state: () => ({
    processing: false,
    processing_item_count: 0,
    doc_id: '',
    view: 'table_selection',
  }),
  getters: {},
  actions: {
    handleLoader(processing: boolean) {
      if (processing) {
        this.processing_item_count++;
      } else {
        this.processing_item_count--;
      }

      if (this.processing_item_count < 0) {
        this.processing_item_count = 0;
      }

      if (this.processing_item_count > 0) {
        this.processing = true;
      } else {
        this.processing = false;
      }
    },
  },
});
